import { composeAND } from "./strategy";
import { IClientConfig } from "src/client-config/config";
import { BetTypeEnum } from "src/constants/enums/betType";
import { ISelection } from "src/constants/interfaces/bet";
import { getEffectiveSelectionsCount } from "src/common/helpers/betBuilder";

const configEnabled = (config: IClientConfig) => config.enableBankerBet;

const betTypeSystem = (config: IClientConfig, betType: BetTypeEnum) => betType === BetTypeEnum.System;

// A bet builder card behaves like ONE leg for system math — banker bet
// requires at least 3 effective legs, so a 3-leg BB card alone is NOT enough.
const enoughSelectionsCount = (config: IClientConfig, betType: BetTypeEnum, selections: ISelection[]) =>
  getEffectiveSelectionsCount(selections) >= 3;

export const bankerBetEnabled = composeAND(enoughSelectionsCount, betTypeSystem, configEnabled);
